import { useBudgetOptimizationContext } from '@/dashboards/BudgetOptimization/hooks/useBudgetOptimizationContext';
import { OutOfBoundsWarningModal } from './OutOfBoundsWarningModal';

export const ModalWithContext = ({
    show,
    channelInfo,
    onClose,
}: {
    show: boolean;
    channelInfo: {
        channelName?: string;
        min?: number;
        max?: number;
    } | null;
    onClose: () => void;
}) => {
    const { variableValues, onSubmit } = useBudgetOptimizationContext();

    if (!show) return null;

    return (
        <OutOfBoundsWarningModal
            onClose={() => {
                if (channelInfo?.channelName && variableValues && onSubmit) {
                    const variableKey = Object.keys(variableValues).find(
                        (k) =>
                            variableValues[k]?.locked &&
                            k === channelInfo.channelName,
                    );
                    if (variableKey) {
                        onSubmit(variableKey, {
                            ...variableValues[variableKey],
                            investment:
                                variableValues[variableKey]?.investment ?? null,
                            locked: !!variableValues[variableKey]?.locked,
                        });
                    }
                }
                onClose();
            }}
            channelName={channelInfo?.channelName}
            minChannelRecommended={channelInfo?.min}
            maxChannelRecommended={channelInfo?.max}
        />
    );
};
